import {
  Component,
  OnDestroy,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import * as _ from 'lodash';
import { IconsPipe } from '../../../helpers/pipes/icons.pipe';
import { Translator } from 'angular-translator';
import { ProductSearch } from 'app/infrastructure/model/interfaces/productSection.interface';



@Component({
  selector: 'product-section-list',
  templateUrl: './product-section-list.component.html',
  styleUrls: ['./product-provider-list.component.css'],
  providers: [IconsPipe]
})
export class ProductSectionListComponent implements OnDestroy {
  _products: ProductSearch[];
  sections: string[];
  groupedProducts: _.Dictionary<ProductSearch[]>;
  selectedProductId: string = null;

  @Input() set products(products: ProductSearch[]) {
    this._products = products;
    this.groupedProducts = _.groupBy(this._products, 'section');
    const sections = Object.keys(this.groupedProducts);
    this.sections = _.orderBy(sections, section => section.toLowerCase(), ['asc']);
    this.selectedProductId = null;
    this.onSelect.emit(null);
  }

  get products(): ProductSearch[] {
    return this._products;
  }

  @Output() onSelect: EventEmitter<ProductSearch> = new EventEmitter<ProductSearch>();

  constructor(private translator: Translator) {

  }

  ngOnDestroy() {
    this.onSelect.emit(null);
  }

  selectProduct(product: ProductSearch) {
    this.selectedProductId = product.id;
    this.onSelect.emit(product);
  }

  getBranchIcon(branch: string) {
    const branchsMapping = {
      'Autos': 'fa-car',
      'Motos': 'fa-motorcycle',
      'Television por cable': 'fa-television',
      'Subscripcion periodico': 'fa-newspaper-o',
      'Compra protegida': 'fa-shopping-cart',
      'Bolso protegido': 'fa-shopping-bag',
      'Asistencia hogar': 'fa-home',
      'Accidentes personales': 'acc-pers-icon',
      'Robo en cajero': 'robo-cajero-icon',
      'Asistencia vehiculo': 'asist-vehiculo-icon',
    };

    return branchsMapping[branch] || '';
  }

  getIconTooltipByProductType(type: string) {
    const tooltipMapping = {
      'Online': this.translator.instant('DISPONIBLE_ONLINE'),
      'Offline':  this.translator.instant('DISPONIBLE_OFFLINE'),
      'Batch':  this.translator.instant('DISPONIBLE_BATCH'),
    };
    return tooltipMapping[type] || '';
  }
}




// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/product-search/components/product-section-list.component.ts